import script from "./AppDateString.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDateString.vue?vue&type=script&setup=true&lang=ts"

import "./AppDateString.vue?vue&type=style&index=0&id=35de1746&lang=scss"

const __exports__ = script;

export default __exports__